module.exports = __webpack_public_path__ + "static/media/casper.a755dcc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pictures/pics/casper.jpg
// module id = 134
// module chunks = 0